export default __webpack_public_path__ + "static/media/logo-dzikra.6b75c0c0.jpg";